import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPostgresqlComponent } from './simple-icons-postgresql.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPostgresqlComponent ],
    exports:      [ SimpleIconsPostgresqlComponent ],
    bootstrap:    []
})
export class SimpleIconsPostgresqlModule {}
